import { render, staticRenderFns } from "./TechnicalReport.vue?vue&type=template&id=27858167&scoped=true"
var script = {}
import style0 from "./TechnicalReport.vue?vue&type=style&index=0&id=27858167&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27858167",
  null
  
)

export default component.exports